import type { RouteRecordRaw } from 'vue-router'

import redirectIfWebview from '~/scopes/webviews/middleware/redirectIfWebview'

import {
  SHOPPING_ASSISTANT,
  SHOPPING_ASSISTANT_NEW,
  SHOPPING_ASSISTANT_NEW_WEBVIEW,
  SHOPPING_ASSISTANT_WEBVIEW,
} from './routes.constants'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: 'assistant/new',
      name: SHOPPING_ASSISTANT_NEW,
      component: () =>
        import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
      meta: {
        layout: false,
        middleware: [redirectIfWebview],
        owners: ['bot-group-ai-shopping-assistant-front'],
        tracking: { contentGroup: 'AI Assistant' },
      },
    },
    {
      path: 'assistant/:chatId?',
      name: SHOPPING_ASSISTANT,
      component: () =>
        import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
      meta: {
        layout: false,
        middleware: [redirectIfWebview],
        owners: ['bot-group-ai-shopping-assistant-front'],
        tracking: { contentGroup: 'AI Assistant' },
      },
    },
    {
      path: 'webview',
      meta: {
        layout: 'webview-default',
      },
      children: [
        {
          path: 'assistant/new',
          name: SHOPPING_ASSISTANT_NEW_WEBVIEW,
          component: () =>
            import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
          meta: {
            isWebview: true,
            shouldDisplayEdgeToEdge: true,
            owners: ['bot-group-ai-shopping-assistant-front'],
            tracking: { contentGroup: 'AI Assistant' },
          },
        },
        {
          path: 'assistant/:chatId?',
          name: SHOPPING_ASSISTANT_WEBVIEW,
          component: () =>
            import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
          meta: {
            isWebview: true,
            shouldDisplayEdgeToEdge: true,
            owners: ['bot-group-ai-shopping-assistant-front'],
            tracking: { contentGroup: 'AI Assistant' },
          },
        },
      ],
    },
  ]
}
